export default __webpack_public_path__ + "static/media/illustrasi-hasil-kuis.4a21ca52.svg";